/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSortDirection } from './InternalApiSortDirection';
import {
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionFromJSONTyped,
    InternalApiSortDirectionToJSON,
    InternalApiSortDirectionToJSONTyped,
} from './InternalApiSortDirection';

/**
 * 
 * @export
 * @interface InternalApiTransactionByIdsQuery
 */
export interface InternalApiTransactionByIdsQuery {
    /**
     * 
     * @type {string}
     * @memberof InternalApiTransactionByIdsQuery
     */
    orderBy?: string;
    /**
     * 
     * @type {InternalApiSortDirection}
     * @memberof InternalApiTransactionByIdsQuery
     */
    direction?: InternalApiSortDirection;
    /**
     * 
     * @type {string}
     * @memberof InternalApiTransactionByIdsQuery
     */
    query?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalApiTransactionByIdsQuery
     */
    ids: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof InternalApiTransactionByIdsQuery
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiTransactionByIdsQuery
     */
    size: number;
}



/**
 * Check if a given object implements the InternalApiTransactionByIdsQuery interface.
 */
export function instanceOfInternalApiTransactionByIdsQuery(value: object): value is InternalApiTransactionByIdsQuery {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function InternalApiTransactionByIdsQueryFromJSON(json: any): InternalApiTransactionByIdsQuery {
    return InternalApiTransactionByIdsQueryFromJSONTyped(json, false);
}

export function InternalApiTransactionByIdsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionByIdsQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'orderBy': json['orderBy'] == null ? undefined : json['orderBy'],
        'direction': json['direction'] == null ? undefined : InternalApiSortDirectionFromJSON(json['direction']),
        'query': json['query'] == null ? undefined : json['query'],
        'ids': json['ids'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function InternalApiTransactionByIdsQueryToJSON(json: any): InternalApiTransactionByIdsQuery {
    return InternalApiTransactionByIdsQueryToJSONTyped(json, false);
}

export function InternalApiTransactionByIdsQueryToJSONTyped(value?: InternalApiTransactionByIdsQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderBy': value['orderBy'],
        'direction': InternalApiSortDirectionToJSON(value['direction']),
        'query': value['query'],
        'ids': value['ids'],
        'page': value['page'],
        'size': value['size'],
    };
}

